export const BASE_URL = 'https://d2axlk9d80xmkd.cloudfront.net/gardenmother/'
